import React from 'react';

const SVG = ({width = '16px', height = '16px'}) => (
  <svg
    width={width}
    height={height}
    viewBox="43 43 112 112"
    className="bi bi-search"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Search</title>
    <path d="M151.5,139.6l-22.2-22.2c-0.8-0.8-0.8-1.6-0.4-2.5c4.5-7,7-15.2,7-24.2c0-25-20.1-45.1-45.1-45.1S45.7,65.8,45.7,90.8s20.1,45.1,45.1,45.1c9,0,17.2-2.5,24.2-7c0.8-0.4,2.1-0.4,2.5,0.4l22.2,22.2c1.6,1.6,4.1,1.6,5.7,0l5.7-5.7C153.2,143.7,153.2,141.3,151.5,139.6z M91.2,119.5c-16,0-28.7-12.7-28.7-28.7s12.7-28.7,28.7-28.7S120,74.8,120,90.8S107.2,119.5,91.2,119.5z" />
  </svg>
);

export default SVG;
